export default __webpack_public_path__ + "static/media/tacticdefense.ccc351aa.png";